import { FlexBox, Spinner, Text } from '@dixa/lib-shared-habla';
import { colors, sizes } from '@dixa/lib-shared-tokens';

type LoadingProps = {
  /** Some user text */
  text?: string;
  /** Extra classnames */
  className?: string;
  /** Size in pixels */
  size?: number;
  /** Width as CSS value */
  width?: HTMLDivElement['style']['width'];
  /** Height as CSS value */
  height?: HTMLDivElement['style']['height'];
};

export function KnowledgeLoading(props: LoadingProps): JSX.Element {
  const { width = '100%', height = '100%', size = 56, ...rest } = props;

  return (
    <FlexBox
      style={{ width, height, display: 'inline-flex' }}
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      background={colors.neutral['000']}
    >
      <Spinner {...rest} size={size} />
      {props.text && (
        <div style={{ padding: sizes.spacer[300] }}>
          <Text.Paragraph>{props.text}</Text.Paragraph>
        </div>
      )}
    </FlexBox>
  );
}
